import { render, staticRenderFns } from "./GeckoBoard.vue?vue&type=template&id=4ee46ae1&"
import script from "./GeckoBoard.vue?vue&type=script&lang=js&"
export * from "./GeckoBoard.vue?vue&type=script&lang=js&"
import style0 from "./GeckoBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports